import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import gold_rupe_icon_md from "../../assets/images/gold_rupe_md.svg";
import hotel_Icon from "../../assets/images/transctionIcon.svg";
import clockIcon from "../../assets/images/last_minute_deal.svg";
import { fetchEarnedPoints } from "../../redux/slice/earnedPoints";
import { getFieldsValue, formatIndianNumber } from "../../utils/common";
import Spinner from "../../component/spinner/Spinner";
import "./PointHistory.scss";
import NoDataComp from "../../component/NoDataComp";

const EarnedPoints = ({ filteredEarnedPoints }) => {
  const dispatch = useDispatch();
  const { earnedPointsData, loading } = useSelector(
    (state) => state.earnedPoints
  );

  useEffect(() => {
    if (earnedPointsData?.length === 0) {
      dispatch(fetchEarnedPoints());
    }
    // eslint-disable-next-line 
  }, []);

  return (
    <>
      <div className="tabTable">
        <div className="border_bottom_section">
          {filteredEarnedPoints?.length > 0
            ? filteredEarnedPoints?.map((item) => {
                return (
                  <React.Fragment key={item?.id}>
                    <div className="d-flex justify-content-between transction_list">
                    <p className="mobile_content bill">{item?.billing_time
                                            ? moment(
                                                item?.billing_time
                                              ).format("DD MMM YYYY")
                                            : "Not Available"}</p>
                      <div className="hotel_booking_details d-flex align-items-center">
                        {/* <img
                          className="hotel_Icon_div"
                          src={hotel_Icon}
                          alt=""
                        /> */}
                        <div>
                          {/* <p> Shopping</p> */}
                          <h1>
                            {getFieldsValue(
                              item?.extended_fields?.field,
                              "retailer_name"
                            ) || "--"}
                          </h1>
                          <div className="date_expire">
                            <img src={clockIcon} alt="" /> Points Expires on,{" "}
                            {item?.points?.expiry_date
                              ? moment(item?.points?.expiry_date).format(
                                  "DD MMM YYYY"
                                )
                              : "Not Available"}
                          </div>
                        </div>
                      </div>
                      <div className="bookingStatus desktop_content">
                        <p>
                          {" "}
                          Uploaded on :{" "}
                          <span className="high_light_text">
                            {" "}
                            {moment(item?.billing_time).format("Do MMMM")}
                          </span>
                        </p>
                        {/* <p className="coinStatus">Coins yet to earn</p> */}
                      </div>
                      <div className="points_gold">
                        <p className="high_light_text" style={{display: "flex"}}>
                          +{formatIndianNumber(item?.points?.issued)}{" "}
                          <img src={gold_rupe_icon_md} alt="" />
                        </p>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })
            : (loading ? null : <NoDataComp />)}
        </div>
      </div>
      {loading ? (
        <div className="spinner_table_height">
          <Spinner color="black" />
        </div>
      ) : null}
    </>
  );
};

export default EarnedPoints;
